import { useEffect, useState, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { GetUserId } from "../../../../_utilities/getUserInfo";
import * as _ser from "../../../../_redux/_services/ApplicantsSlice";
import { DashboardPlusicon } from "../../../../Icons/DashboardPlusicon";
import * as _sercloud from "../../../../_redux/_services/CloudSourcingSlice";
import { customFieldsAsync } from "../../../../_redux/_services/UserManagerSlice";
import AddApplicantDetailsAssociatedJobs from "./AddApplicantDetailsAssociatedJobs";
import {
  resetSelectedApplicant,
  setSelectedApplicant,
} from "../../../../_redux/SelectedApplicantSlice";
import {
  getCandidateInternalStatus,
  getCandidateStatusCustomValues,
} from "../../../../_utilities/internalexternalhelper";
import DetailCard from "../../../../components/DetailCard/DetailCard";
import Pagination from "../../../../components/DynamicTable/Pagination";
import { GetTimeZone } from "../../../../_utilities/GetTimeZone";
import "./ApplicantDetailsAssociatedJobs.css";

const CARDS_PER_PAGE = 12;

const initalState = { data: null, message: "", isloader: true };

const ApplicantDetailsAssociatedJobs = ({
  data,
  selectedAppliant,
  onReceiveProps,
}) => {
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [AccociatedJobSeekerList, setAccociatedJobSeekerList] = useState([]);
  const [showJobDetails, setShowJobDetails] = useState(false);
  const [filterValue, setFilterValue] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [getData, setGetData] = useState("");
  const [questionsData, setQuestionsData] = useState([]);
  const [componentType, setComponentType] = useState("AssociatedJobs");
  const [isValidUser, setIsValidUser] = useState(false);
  const [showSelectedIds, setShowSelectedIds] = useState(false);
  const [savedApplicant, setSavedApplicant] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pannelobj, setPannelobj] = useState({
    title: "",
    description: "",
    bgImage: "",
    navigateTo: "",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [candidateStatusValues, setCandidateStatusValues] = useState([]);

  const nextPathValue = useSelector((state) => state.SeletedNextPath.value);
  const customFieldsData = useSelector((state) => state.CustomFields.data);

  useEffect(() => {
    if (!data) return;
    setAccociatedJobSeekerList(data);
    setCurrentPage(1);
    setComponentType("AssociatedJobs");
    dispatch(_ser.getApplicantJobsStartReducer(initalState));
  }, [data]);

  useEffect(() => {
    if (!selectedAppliant) return;
    setSavedApplicant(selectedAppliant);
  }, [selectedAppliant]);

  useEffect(() => {
    if (nextPathValue === "null") {
      setShowJobDetails(false);
      localStorage.setItem("AssociatedMenu", "false");
      window.dispatchEvent(new Event("storage"));
    }
  }, [nextPathValue]);

  const GetApplicantJobsCode = useSelector(
    (state) => state.GetApplicantJobs.code,
  );

  useEffect(() => {
    if (GetApplicantJobsCode === 404) {
      setIsValidUser(true);
    }
  }, [GetApplicantJobsCode]);

  useEffect(() => {
    const init = async () => {
      const userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
    };
    init();
  }, []);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const array = getCandidateStatusCustomValues(customFieldsData);
      setCandidateStatusValues(array);
    }
  }, [customFieldsData]);

  // ─── Filtered + paginated data ───
  const filteredList = useMemo(() => {
    if (!searchQuery.trim()) return AccociatedJobSeekerList;
    const q = searchQuery.toLowerCase();
    return AccociatedJobSeekerList.filter(
      (item) =>
        (item.jobCode || "").toLowerCase().includes(q) ||
        (item.jobTitle || "").toLowerCase().includes(q) ||
        (item.clientName || "").toLowerCase().includes(q) ||
        (item.documentName || "").toLowerCase().includes(q),
    );
  }, [AccociatedJobSeekerList, searchQuery]);

  const paginatedList = useMemo(() => {
    const start = (currentPage - 1) * CARDS_PER_PAGE;
    return filteredList.slice(start, start + CARDS_PER_PAGE);
  }, [filteredList, currentPage]);

  // Reset page when search query changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  const handleSearchChange = useCallback((e) => {
    setFilterValue(e.target.value);
  }, []);

  const handleSearchSubmit = useCallback(
    (e) => {
      if (e.key === "Enter") {
        setSearchQuery(filterValue);
      } else if (e.key === "Backspace" && filterValue.length <= 1) {
        setSearchQuery("");
      }
    },
    [filterValue],
  );

  const handleClearSearch = useCallback(() => {
    setFilterValue("");
    setSearchQuery("");
  }, []);

  const handleCardClick = useCallback((item) => {
    setIsRightSidePannel(true);
    setComponentType("jobProfile");
    let obj = {
      jobopeningID: item.jobopeningID,
      asscoId: item.asscoId,
      status: item.status,
    };
    setGetData(obj);
    setPannelobj({
      title: `${item.jobTitle} (${item.jobCode})`,
      description: "",
      bgImage: "",
      navigateTo: `/ats/layout/jobpostings/view/${item.jobopeningID}`,
    });
  }, []);

  // ─── Build card body fields for each job ───
  const buildJobFields = useCallback((item) => {
    const fields = [];

    // Always show client — show "-" if empty
    fields.push({ value: item.clientName || "-", bold: true });

    // Use fileType from service to determine icon
    const iconType =
      (item.fileType || "").toLowerCase() === "doc" ||
      (item.fileType || "").toLowerCase() === "docx"
        ? "doc"
        : "pdf";
    if (item.documentName) {
      fields.push({ icon: iconType, value: item.documentName });
    } else {
      fields.push({ value: "-" });
    }

    fields.push({
      label: "Status",
      value: item.status || "-",
    });

    fields.push({
      label: "Applied on",
      value: item.associatedDate ? GetTimeZone(item.associatedDate) : "-",
    });

    fields.push({
      label: "Updated on",
      value: item.lastUpdated || "-",
    });

    return fields;
  }, []);

  const onReceiveActionHandler = async (type, object) => {
    setShowTable(false);
    if (type === "pagination") {
      onReceiveProps("associatedJobs");
    } else if (type === "cancelSearchResult") {
      setFilterValue("");
      onReceiveProps("associatedJobs");
    } else if (type === "confirmDel") {
      DeleteRecords(object);
    } else if (type === "detailspage") {
      handleCardClick(object);
    } else if (type === "viewAnswers") {
      let Obj = {
        cs_id: object.cs_id,
        job_id: object.jobopeningID,
        applicant_id: object.applicantID,
      };
      dispatch(_sercloud.getQuestionsAnswersReducerAsync(Obj));
    } else if (type === "pageRange") {
      // kept for backward compatibility
    }
    setTimeout(() => {
      setShowTable(true);
    }, 100);
  };

  const delApplicantJobsCode = useSelector(
    (state) => state.DeleteApplicantJobs.data,
  );

  const responseOfQuestionAnswer = useSelector(
    (state) => state.GetQuestionsAnswers.data,
  );

  const DeleteRecords = async (object) => {
    if (object.sourcedFrom === "Cloudsourcing") {
      object["portalassociatedJobs"] = "csassociatedJobs";
    } else if (object.sourcedFrom === "Employee Portal") {
      object["portalassociatedJobs"] = "eassociatedJobs";
    } else if (object.sourcedFrom === "Vendorsourcing") {
      object["portalassociatedJobs"] = "vsassociatedJobs";
    } else {
      object["portalassociatedJobs"] = "associatedJobs";
    }
    object["id"] = object[0].jobopeningID;
    let array = object.map((i) => i.asscoId);
    let deleteIds = { ids: array };
    dispatch(
      _ser.deleteApplicantJobsAsync(selectedAppliant?.id, object, deleteIds),
    );
  };

  useEffect(() => {
    if (delApplicantJobsCode === 200) {
      setAccociatedJobSeekerList([]);
      onReceiveProps("associatedJobs");
      dispatch(_ser.deleteApplicantJobsStartReducer(initalState));
    }
  }, [delApplicantJobsCode]);

  useEffect(() => {
    if (responseOfQuestionAnswer && responseOfQuestionAnswer.length > 0) {
      let newObj = JSON.parse(JSON.stringify(responseOfQuestionAnswer));
      newObj.forEach((item) => {
        item.answer = JSON.parse(item.answer);
      });
      setQuestionsData(newObj);
      setIsRightSidePannel(true);
      setComponentType("Questions&Answers");
      dispatch(_sercloud.getQuestionsAnswersStartReducer({}));
    }
  }, [responseOfQuestionAnswer]);

  const onReceivePropsHandler = (pannel, load) => {
    if (load === "getFetch") {
      setIsRightSidePannel(pannel);
      onReceiveProps("associatedJobs");
    } else if (load === "close") {
      setIsRightSidePannel(pannel);
      setComponentType("AssociatedJobs");
    }
  };

  return (
    <>
      {!showJobDetails && !isValidUser ? (
        <>
          {/* ── Search + Action Bar ── */}
          <div className="detail-card-search">
            <div className="detail-card-search__input-wrapper">
              {!filterValue && (
                <span className="detail-card-search__icon">
                  <SearchIcon />
                </span>
              )}
              <input
                type="text"
                className="detail-card-search__input"
                placeholder="Search by Job code, Title"
                value={filterValue}
                onChange={handleSearchChange}
                onKeyDown={handleSearchSubmit}
                aria-label="Search associated jobs"
                style={filterValue ? { paddingLeft: "18px" } : {}}
              />
              {filterValue && (
                <button
                  type="button"
                  className="detail-card-search__clear"
                  onClick={handleClearSearch}
                  aria-label="Clear search"
                >
                  <CloseIcon fontSize="small" />
                </button>
              )}
            </div>
            <button
              type="button"
              className="detail-card-search__action-btn"
              onClick={() => setIsRightSidePannel(true)}
            >
              <DashboardPlusicon width={22} height={22} />
              <span>Associate Jobs</span>
            </button>
          </div>

          {/* ── Card Grid ── */}
          {paginatedList.length > 0 ? (
            <div className="detail-card-grid">
              {paginatedList.map((item, idx) => (
                <DetailCard
                  key={item.asscoId || item.jobopeningID || idx}
                  headerTitle={`${item.jobTitle || ""} (${item.jobCode || ""})`}
                  badge={
                    item.percentage !== "N/A" && item.percentage != null
                      ? item.percentage
                      : 'N/A'
                  }
                  bodyFields={buildJobFields(item)}
                  footerActions={[]}
                  onClick={() => handleCardClick(item)}
                  testId={`job-card-${item.asscoId || idx}`}
                />
              ))}
            </div>
          ) : (
            <div className="detail-card-empty">
              <img
                src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                alt="No data"
              />
              No Associated Jobs
            </div>
          )}

          {/* ── Pagination ── */}
          <Pagination
            currentPage={currentPage}
            totalCount={filteredList.length}
            pageSize={CARDS_PER_PAGE}
            onPageChange={setCurrentPage}
            className="detail-card-pagination"
          />
        </>
      ) : (
        ""
      )}

      {showJobDetails ? <div id="InnerComponents"></div> : null}

      {isRightSidePannel && (
        <AddApplicantDetailsAssociatedJobs
          componentType={componentType}
          isRightSidePannel={isRightSidePannel}
          AccociatedJobSeekerList={AccociatedJobSeekerList}
          onPropsReceive={onReceivePropsHandler}
          questionsData={questionsData}
          getData={getData}
          pannelobj={pannelobj}
        />
      )}
    </>
  );
};

export default ApplicantDetailsAssociatedJobs;
